import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface AttributionState {
  utm_source: string | null
  utm_medium: string | null
  utm_campaign: string | null
  utm_term: string | null
  referrer: string | null
  setAttribution: (data: Partial<AttributionState>) => void
  clearAttribution: () => void
}

export const useAttributionStore = create<AttributionState>()(
  persist(
    (set) => ({
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
      referrer: null,
      setAttribution: (data) => set((state) => ({ ...state, ...data })),
      clearAttribution: () => set({
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        referrer: null
      })
    }),
    {
      name: 'attribution-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
)
